import React, { Component } from 'react';
// Stage 3.8 (Enterprise Candidate Portal Certification): was importing antd's own Button instead
// of the shared components/controls/Button every sibling screen (NewLogin.jsx, ResetPassword.jsx,
// SetPassword.js) uses — a leftover from the legacy ForgotPassword.jsx never fixed when _new was
// created. antd's Button layers its own .ant-btn base styling under this app's .button-global
// classes, risking a subtly different height/shadow than every other button in the app. The shared
// Button takes its label via a `value` prop (not children) — every call site below was updated to
// match, same JSX content, just relocated.
import Button from 'components/controls/Button';
import LoadingSpinner from 'components/enterprise/LoadingSpinner';
import MyInput from 'components/controls/MyInput';
import _validator from 'modules/validator';
import { GENERAL_ERROR_MESSAGE, PASSWORD_UPDATE_SUCCESS, FORGOT_PASSWORD_TIMER } from 'constants/constants';
import _notification from 'modules/notification';
import _authService from 'modules/AuthService';
import { routes } from 'routes/Routes';
import PublicFooter from "../components/Footer/PublicFooter";
import Text, { resolveText } from 'components/Text/Text';
import { getCurrentLocale, getCurrentDisplayMode } from 'modules/LanguageContext';

// Stage 3.9 (Task 2/5): validation messages are set via setState with a plain string (MyInput's
// errorMessage prop is PropTypes.string), so they use the plain resolveText() helper — a class
// component's methods run outside React's render cycle and can't call the useLanguage() hook. See
// modules/LanguageContext.js's getCurrentLocale/getCurrentDisplayMode, and ResetPassword.jsx's
// identical comment.
function tr(key) {
  return resolveText(key, getCurrentLocale(), getCurrentDisplayMode());
}

class ForgotPassword_new extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      Application_Id: "",
      email: "",
      Mobile_Number: "",
      NewPassword: "",
      ConfirmPassword: "",
      OTP: "",

      Application_IdError: "",
      emailError: "",
      Mobile_NumberError: "",
      NewPasswordError: "",
      ConfirmPasswordError: "",
      OTPError: "",

      isOtpSendFlag: false,

      timeLeft: FORGOT_PASSWORD_TIMER, // change seconds countdown in env
      isResendDisabled: false,
      resData: {}
    };
    this.timerId = null;
  }

  getInfo = async (ev) => {
    await _authService.clearSessionHist();

    this.setState({ isLoading: true });
    try {
      const response = await _authService.cachePortalConfiguration();
      if (response.status == 200 && response.data) {
        this.setState({ isLoading: false, resData: { ...response.data } })

      }
      else {
        this.setState({ isLoading: false });
        _notification.showMessage('error', response.data.Message);
      }
    } catch (e) {
      this.setState({ isLoading: false })

    }

  }

  componentDidMount() {
    this.getIpAddress();
    this.getInfo();
  }

  getIpAddress = async (ev) => {

    this.setState({ isLoading: true });
    try {
      const response = await _authService.getClientIP();
      if (response) {
        this.startTimer();
        this.setState({ isLoading: false })
      }
      else {
        this.props.history.push(routes.home.basePath)
      }
    } catch (e) {
      this.setState({ isLoading: false })
    }
  }

  componentWillUnmount() {
    clearInterval(this.timerId);
  }

  startTimer = () => {
    if (this.timerId) {
      clearInterval(this.timerId);
    }
    this.timerId = setInterval(() => {
      this.setState((prevState) => {
        if (prevState.timeLeft > 1) {
          return { timeLeft: prevState.timeLeft - 1 };
        } else {
          clearInterval(this.timerId);
          return { timeLeft: 0, isResendDisabled: false };
        }
      });
    }, 1000);
  };

  onTextChange = ({ target: { name, value } }) => {
    switch (name) {
      case "email":
        if (_validator.verifyEmail(value)) {
          if (value.length > 50) {
            return;
          }
          else {
            this.setState({
              email: value,
              emailError: ""
            });
          }
        } else {
          this.setState({
            email: value,
            emailError: tr('forgotPassword.invalidEmail')
          });
        }
        break;
      case "Application_Id":
        if (value && value.trim() !== "") {
          if (_validator.isDigit(value)) {
            if (value.length > 10) {
              return;
            }
            else {
              this.setState({
                Application_Id: value,
                Application_IdError: ""
              });
            }
          }
        }
        else {
          this.setState({
            Application_Id: "",
            Application_IdError: tr('forgotPassword.pleaseEnterApplicationId')
          });
        }
        break;

      case "Mobile_Number":
        if (value && value.trim() !== "") {
          if (_validator.isDigit(value)) {
            if (value.length > 10) {
              return;
            }
            else {
              this.setState({
                Mobile_Number: value,
                Mobile_NumberError: ""
              });
            }
          }
          else {
            this.setState({
              // Mobile_Number: value,
              Mobile_NumberError: tr('forgotPassword.pleaseEnterValidMobileNumber')
            });
          }

        }
        else {
          this.setState({
            Mobile_Number: "",
            Mobile_NumberError: tr('forgotPassword.pleaseEnterMobileNumber')
          });
        }
        break;

      case "NewPassword":
        if (value && value.trim() !== "") {
         if (value.length > 25) {
              return;
            }
            else {
              this.setState({
                NewPassword: value,
                NewPasswordError: ""
              });
            }
          }
        else {
          this.setState({
            NewPassword: "",
            NewPasswordError: tr('passwordCommon.pleaseEnterNewPassword')
          });
        }
        break;

      case "ConfirmPassword":
        if (name === "ConfirmPassword") {
          if (value && value.trim() !== "") {
          if (value.length > 25) {
                return;
              }
              else {
                this.setState({
                  ConfirmPassword: value,
                  ConfirmPasswordError: ""
                });
              }
            }
          else {
            this.setState({
              ConfirmPassword: "",
              ConfirmPasswordError: tr('passwordCommon.pleaseEnterConfirmPassword')
            });
          }
        }
        break;

      case "OTP":
        if (value && value.trim() !== "") {
          if (_validator.isDigit(value)) {
          if (value && value.trim().length >= 7) {
            this.setState({
              OTP: this.state.OTP,
              OTPError: tr('forgotPassword.pleaseEnterValidOtp')
            });
          }
          else {
            this.setState({
              OTP: value,
              OTPError: ""
            });
          }}
        }
        else {
          this.setState({
            OTP: "",
            OTPError: tr('forgotPassword.pleaseEnterOtp')
          });
        }
        break;
      default:
        this.setState({ [name + "State"]: "success" });
    }
  }

  validateFormData = () => {
    let body = this.state;

    this.setState({
      Application_IdError: "",
      emailError: "",
      Mobile_NumberError: "",
      NewPasswordError: "",
      ConfirmPasswordError: "",
      OTPError: ""
    });

    let hasError = false;

    if (!this.state.Application_Id) {
      this.setState({ Application_IdError: tr('forgotPassword.pleaseEnterApplicationId') });
      hasError = true
    }

    if (!this.state.email) {
      this.setState({ emailError: tr('forgotPassword.pleaseEnterEmail') });
      hasError = true
    }

    if (!this.state.Mobile_Number) {
      this.setState({ Mobile_NumberError: tr('forgotPassword.pleaseEnterMobileNumber') });
      hasError = true
    }

    if (!body.NewPassword) {
      this.setState({ NewPasswordError: tr('passwordCommon.pleaseEnterNewPassword') });
      hasError = true
    }

    if (!body.ConfirmPassword) {
      this.setState({ ConfirmPasswordError: tr('passwordCommon.pleaseEnterConfirmPassword') });
      hasError = true
    }

    if ((body.NewPassword && body.ConfirmPassword) && (body.NewPassword !== body.ConfirmPassword)) {
      _notification.showMessage('error', tr('forgotPassword.passwordsNotMatched'));
      this.setState({
        ConfirmPasswordError: tr('forgotPassword.passwordsNotMatched'),
        NewPasswordError: tr('forgotPassword.passwordsNotMatched')
      });
      hasError = true
    }

    if (!body.OTP) {
      this.setState({ OTPError: tr('forgotPassword.pleaseEnterOtp') });
      hasError = true
    }
    else if (body.OTP && body.OTP.length !== 6) {
      this.setState({ OTPError: tr('forgotPassword.pleaseEnterValidOtp') });
      hasError = true
    }

    return hasError;
  }

  forgotPassword = async () => {

    if (this.validateFormData()) {
      return
    }

    this.setState({
      isLoading: true
    })

    const params = {
      Application_Id: this.state.Application_Id,
      email: this.state.email,
      Mobile_Number: this.state.Mobile_Number,
      NewPassword: this.state.NewPassword,
      ConfirmPassword: this.state.ConfirmPassword,
      OTP: this.state.OTP
    }
    try {
      const response = await _authService.ForgotStudentPassword(params);
      if (response.data.IsSuccess === true) {

        _notification.showMessage('success', PASSWORD_UPDATE_SUCCESS);

        this.setState({
          isLoading: false,
          Application_Id: "",
          email: "",
          Mobile_Number: "",
          NewPassword: "",
          ConfirmPassword: "",
          OTP: "",

          Application_IdError: "",
          emailError: "",
          Mobile_NumberError: "",
          NewPasswordError: "",
          ConfirmPasswordError: "",
          OTPError: "",

          isOtpSendFlag: ""
        });

        setTimeout(function () {
          window.location.href = "/";
        }, 2000);

      }
      else {
        this.setState({

          isLoading: false,
          Application_Id: "",
          email: "",
          Mobile_Number: "",
          NewPassword: "",
          ConfirmPassword: "",
          OTP: "",

          Application_IdError: "",
          emailError: "",
          Mobile_NumberError: "",
          NewPasswordError: "",
          ConfirmPasswordError: "",
          OTPError: "",

          isOtpSendFlag: false,

        })
        _notification.showMessage('error', response.data.Message);
      }
    } catch (e) {
      this.setState({
        isLoading: false
      })
      _notification.showMessage('error', GENERAL_ERROR_MESSAGE);
    }
  }

  validateOTPFormData = () => {
    let body = this.state;

    this.setState({
      Application_IdError: "",
      emailError: "",
      Mobile_NumberError: "",
    });

    let hasError = false;

    if (!body.Application_Id) {
      this.setState({ Application_IdError: tr('forgotPassword.pleaseEnterApplicationId') });
      hasError = true
    }

    if (!body.email) {
      this.setState({ emailError: tr('forgotPassword.pleaseEnterEmail') });
      hasError = true
    }

    if (!body.Mobile_Number) {
      this.setState({ Mobile_NumberError: tr('forgotPassword.pleaseEnterMobileNumber') });
      hasError = true
    }

    return hasError;
  }

  sendOTP = async (flag) => {
    if (this.validateOTPFormData()) {
      return
    }

    this.setState({
      isLoading: true
    })

    const params = {
      Application_Id: this.state.Application_Id,
      email: this.state.email,
      Mobile_Number: this.state.Mobile_Number
    }

    try {
      const response = await _authService.ForgetPasswordSendOTP(params);
      if (response.data.IsSuccess === true) {
        _notification.showMessage('success', response.data.Message);
        this.setState({
          timeLeft: 300, isResendDisabled: true,
          isLoading: false,
          Application_IdError: "",
          emailError: "",
          Mobile_NumberError: "",
          isOtpSendFlag: true
        }, () => {
          this.startTimer();
        });
      }
      else {
        this.setState({
          isLoading: false
        })
        if (response.data.Message) {
          _notification.showMessage('error', response.data.Message);
        } else {
          _notification.showMessage('error', tr('forgotPassword.invalidUserInfo'));
        }
      }
    } catch (e) {
      this.setState({
        isLoading: false
      })
      _notification.showMessage('error', GENERAL_ERROR_MESSAGE);
    }
  }
  render() {
    // Phase C.7.4D-R5.1 (§4 footer full-width root cause): `align-items-center` was already here
    // pre-R5 but was completely inert — the div was plain `display:block`, and `align-items` only
    // affects flex/grid containers. Giving this div `display:flex` (via `ent-fp-shell`, R5) silently
    // activated it — Bootstrap's utility class carries `!important`, so every flex child (the card row
    // AND <PublicFooter/>) shrank to content width and centered instead of stretching full-width.
    // Removed here rather than fought with `!important`, since it never did anything intentional.
    return (

      <div className="position-relative w-100 m-auto form-wrap candidate ent-fp-shell">
        {this.state.isLoading && <LoadingSpinner />}

        <div className=" d-flex justify-content-center ent-fp-center-row">


          {/* Phase C.7.4D-R2 (§2A Forgot Password Scroll Root-Cause Fix): was `m-5` (3rem/45px on
              all 4 sides) — with the flex parent's own `justify-content-center` already handling
              horizontal centering, m-5's horizontal component was redundant, and its 45px top+bottom
              (90px combined) was the single largest contributor to this page's unnecessary desktop
              vertical scroll (root-cause traced through the full header/toolbar/card/footer chain —
              no min-height:100vh rule exists anywhere in it; this was ordinary margin/padding
              stacking).
              Phase C.7.4D-R3 (§3 remaining scroll, follow-up measurement): `document.documentElement.
              scrollHeight` at exactly 900px viewport height reads as 900 with zero overflow, but that
              metric clamps to viewport height and hides genuine overflow at shorter (very ordinary)
              browser-window heights — direct `getBoundingClientRect()` measurement showed the actual
              content height is 677px, which starts overflowing between ~650-700px effective viewport
              height (a realistic laptop-with-browser-chrome height). `my-3`→`my-2` (15px→7.5px/side)
              and `p-4`→`p-3` (22.5px→15px/side) trim another 30px combined; see the `.forgot-password-
              body .form-group` override below (themes.scss) for the rest. */}
          <div className="my-2 d-flex forgot-password-card w-100 p-3">
            <div className="forgot-password-card-inner w-100">
              <div className="mt-2 registrationSize text-center">
                <Text k="forgotPassword.pageHeading" />
              </div>

              <div className="forgot-password-body mt-3">
                {!this.state.isOtpSendFlag && (
                  <>
                    <div className="form-group">
                      <MyInput id="Application_Id"
                        type="text"
                        placeholder={tr('forgotPassword.applicationIdPlaceholder')}
                        name="Application_Id"
                        value={this.state.Application_Id}
                        onChange={this.onTextChange}
                        isRequired={true}
                        errorState={this.state.Application_IdError}
                        errorMessage={this.state.Application_IdError}

                        // Phase C.7.4D-R1 (§4/§7-adjacent finding): the redundant inner
                        // .displayInGrid wrapper (now removed) made this the only heading in the
                        // app whose .displayInGrid has a real <div> first-child — the shared
                        // bilingual "/" separator rule (themes.scss, `.forgot-password-card
                        // .form-group .displayInGrid > div:first-of-type::after`) matches a div
                        // child specifically, not <Text>'s own <span> output, so this was the one
                        // heading pattern actually triggering it — live-confirmed as a dangling
                        // " / " with nothing after it. Every other page's headings already use
                        // this exact single-wrapper shape (see Registration_new.jsx) and never
                        // triggered it. No CSS changed — this now matches that existing, correct
                        // convention instead of being a one-off exception.
                        heading={
                          <div className='displayInGrid'><Text k="forgotPassword.applicationIdLabel" /></div>
                        }
                      />
                    </div>

                    <div className="mt-2 form-group">
                      <MyInput id="email"
                        type="text"
                        placeholder={tr('forgotPassword.emailPlaceholder')}
                        name="email"
                        value={this.state.email}
                        onChange={this.onTextChange}
                        isRequired={true}
                        errorState={this.state.emailError}
                        errorMessage={this.state.emailError}

                        // Phase C.7.4D-R1 (§4/§7-adjacent): see Application_Id's identical fix above.
                        heading={
                          <div className='displayInGrid'><Text k="forgotPassword.emailLabel" /></div>
                        }
                      />
                    </div>
                    <div className="mt-2 form-group">
                      <MyInput id="Mobile_Number"
                        type="text"
                        placeholder={tr('forgotPassword.mobileNumberPlaceholder')}
                        name="Mobile_Number"
                        value={this.state.Mobile_Number}
                        onChange={this.onTextChange}
                        isRequired={true}
                        errorState={this.state.Mobile_NumberError}
                        errorMessage={this.state.Mobile_NumberError}

                        // Phase C.7.4D-R1 (§4/§7-adjacent): see Application_Id's identical fix above.
                        heading={
                          <div className='displayInGrid'><Text k="forgotPassword.mobileNumberLabel" /></div>
                        }
                      />
                    </div>
                    {/* Phase C.7.4D-R3 (§3): mt-4 -> mt-3, part of the remaining-scroll trim. */}
                    {/* Phase C.7.4D-R5.1 (§A1): `ent-fp-actions` adds a deliberate gap between the 2
                        buttons — live-measured previously sitting flush against each other, since
                        `justify-content-between` (spread-apart) and `justify-content-center` (packed
                        together) were both present on this div and only one can win. */}
                    <div className='d-flex justify-content-center mt-3 button-global-group btn2 ent-fp-actions'>

                      <Button
                        className="button-global button-primary autoHeight mw125 mt10 "
                        onClick={() => this.sendOTP()}
                        value={<div className="displayInGrid"><Text k="forgotPassword.sendOtpButton" /></div>}
                      ></Button>

                      <Button className="button-global button-border autoHeight mw125 mt10"
                        onClick={(ev) => { ev.preventDefault(); this.props.history.push(routes.login.path); }}
                        value={<div className="displayInGrid"><Text k="forgotPassword.backToLoginButton" /></div>}
                      ></Button>



                    </div>

                  </>
                )}
                {this.state.isOtpSendFlag && (
                  <>


                    <div className="mt-3 mb-3">
                      <div className="ch-note-alert p-4">
                        <div className="h5 font-weight-bold"><Text k="forgotPassword.noteLabel" /></div>
                        <div>
                          <Text k="forgotPassword.otpSentNote" />
                        </div>
                      </div>
                    </div>
                    <div className="text-center">
                      {!this.state.isResendDisabled && (
                        <div className="mt-4 mb-4">
                          {/* Stage 3.8: added preventDefault — every other link/button in this
                              file already calls it; this one didn't, so clicking Resend also
                              jumped the page to "#". */}
                          <a
                            href="#"
                            onClick={(ev) => { ev.preventDefault(); this.sendOTP("resend"); }}
                            className="button-global button-primary autoHeight d-block m-auto autoWidth"
                          >
                            <Text k="forgotPassword.resendOtpLink" />
                          </a>
                        </div>
                      )}
                    </div>

                    <div className=" form-group">
                      <MyInput
                        id="NewPassword"
                        type="password"
                        placeholder="********"
                        name="NewPassword"
                        value={this.state.NewPassword}
                        onChange={this.onTextChange}
                        isRequired={true}
                        errorState={this.state.NewPasswordError}
                        errorMessage={this.state.NewPasswordError}
                        // Phase C.7.4D-R1 (§4/§7-adjacent): see Application_Id's identical fix above.
                        heading={
                          <div className="displayInGrid">
                            <Text k="passwordCommon.newPasswordLabel" />
                          </div>
                        }
                      />
                    </div>
                    <div className="mt-2 form-group">
                      <MyInput
                        id="ConfirmPassword"
                        type="password"
                        placeholder="********"
                        name="ConfirmPassword"
                        value={this.state.ConfirmPassword}
                        onChange={this.onTextChange}
                        isRequired={true}
                        errorState={this.state.ConfirmPasswordError}
                        errorMessage={this.state.ConfirmPasswordError}
                        // Phase C.7.4D-R1 (§4/§7-adjacent): see Application_Id's identical fix above.
                        heading={
                          <div className="displayInGrid">
                            <Text k="passwordCommon.confirmPasswordLabel" />
                          </div>
                        }
                      />
                    </div>
                    <div className="mt-2 form-group">
                      <MyInput
                        id="OTP"
                        type="text"
                        placeholder={tr('forgotPassword.otpPlaceholder')}
                        name="OTP"
                        value={this.state.OTP}
                        onChange={this.onTextChange}
                        isRequired={true}
                        errorState={this.state.OTPError}
                        errorMessage={this.state.OTPError}
                        // Phase C.7.4D-R1 (§4/§7-adjacent): see Application_Id's identical fix above.
                        heading={
                          <div className="displayInGrid">
                            <Text k="forgotPassword.otpLabel" />
                          </div>
                        }
                      />
                    </div>
                    {/* Phase C.7.4D-R3 (§3): mt-4 -> mt-3, consistent with the non-OTP-sent button row above.
                        Phase C.7.4D-R5.1 (§A1): same `ent-fp-actions` gap fix as the row above, for consistency
                        (this row already had `mr20` on its first button giving it some separation, but carried
                        the same dead `justify-content-between`+`justify-content-center` conflict). */}
                    <div className="d-flex justify-content-center mt-3 button-global-group btn2 ent-fp-actions">
                      <Button className="button-global button-primary autoHeight mw125 mr20 mt10"
                        onClick={() => this.forgotPassword()}
                        value={<div className="displayInGrid"><Text k="resetPassword.submitButton" /></div>}
                      ></Button>
                      <Button
                        className="button-global button-border autoHeight mw125 mt10"
                        onClick={(ev) => { ev.preventDefault(); this.props.history.push(routes.login.path); }}
                        value={<div className="displayInGrid"><Text k="forgotPassword.backToLoginButton" /></div>}
                      ></Button>
                    </div>
                  </>
                )}

              </div>

            </div>
          </div>
        </div>

        {/* Phase C.7.4D-R1 (§2): was a bare <PublicFooter/> with no props — the legacy solid-color,
            full 5-link-row footer, inconsistent with Registration/PrivateLayout's modern gradient
            footer (className="ent-registration-footer" hideLinkBar, established C.7.4C). Same prop
            pair as those two, no change to PublicFooter itself. */}
        <PublicFooter className="ent-registration-footer" hideLinkBar />

      </div>



    );

  }
}

export default ForgotPassword_new;